﻿import config from "../config"
const baseUrl = config.base_url + "container_model/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    remove: {
        url:  baseUrl + "delete",
        type: "get",
    },
    get: {
        url:  baseUrl + "get",
        type: "get",
    },
    listByContainerId: {
        url: baseUrl + "listByContainerId",
        type: "get",
    }
} 
